import React from "react";
import { Message as BasisMessage } from "basis";
import styled, { css } from "styled-components";
import { COLOR } from "./theme";

const StyledWrapper = styled.div`
  p,
  strong {
    color: ${COLOR.LATITUDE_BLUE_INDIGO};
  }

  svg path {
    fill: ${COLOR.LATITUDE_BLUE_INDIGO};
  }
  ${(props) =>
    props.bg === "yellow.t10" ?
    css`
      div:first-child {
        background-color: ${COLOR.YELLOW_LIGHT};
      }
    ` :  
    css`
      div:first-child {
        background-color: ${props.bg};
      }
    `
  }
`;

export const Message = ({ bg, ...props }) => {
  // TODO: use basis when "yellow.t10" is supported

  return (
    <StyledWrapper bg={bg}>
      <BasisMessage {...props} />
    </StyledWrapper>
  );
};
